import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

export default function PaginationCM(props) {
  return (
    <Stack spacing={2} mx="auto" my={2} mb={3}>
      <Pagination
        count={Math.ceil(props.count / 10)}
        page={props.page}
        onChange={props.handleChange}
        color="primary"
      />
    </Stack>
  );
}
